module.exports = __webpack_public_path__ + "static/media/18-8.97961d96.mp3";